export default __webpack_public_path__ + "static/media/timing_1.fc77038d.jpg";